export const environment = {
  production: false,
  // apiEndPoint: 'api',
  apiEndPoint: (window as any).apiEndPoint,
  clientConfig: (window as any).clientConfig
};
